/* eslint-disable no-unused-vars */
import i18next from 'i18next';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  FaEnvelope,
  FaFacebookF,
  FaInstagram,
  FaLinkedin,
  FaPhoneAlt,
  FaTwitter,
  FaYoutube,
} from 'react-icons/fa';
import { FaLinkedinIn } from 'react-icons/fa6';
import { Link } from 'react-router-dom';
// import { Link } from 'react-router-dom'

const FooterFour = () => {
  const { t } = useTranslation();
  return (
    <>
      {/* ================== Footer Four Start ==================*/}
      <footer
        className="footer-area bg-cover mt-0 pd-top-20"
        style={{ backgroundImage: 'url("/assets/img/bg/14.png")' }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-6">
              <div className="widget widget_about">
                <div className="thumb">
                  <img
                    src="/assets/images/logo.png"
                    alt="mini-logo"
                    style={{ height: '2.5em' }}
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="widget widget_about">
                <div className="details">
                  <p>
                    {i18next.language != 'ar' && <FaPhoneAlt />}
                    <a href="tel:+96171539243">(+961)&nbsp;&nbsp;70-712-702</a>
                    {i18next.language == 'ar' && <FaPhoneAlt />}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="widget widget_about">
                <div className="details">
                  <p>
                    {i18next.language != 'ar' && <FaEnvelope />}
                    <a href="mailto:info@axissoftsolutions.com">
                      info@axissoftsolutions.com
                    </a>
                    {i18next.language == 'ar' && <FaEnvelope />}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-2 col-md-6">
              <div className="widget widget_about text-lg-end">
                <ul className="social-media">
                  <li className>
                    <a
                      href="https://www.linkedin.com/in/axis-software-solutions-a401a7349/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <FaLinkedinIn />
                    </a>
                  </li>
                  {/* <li>
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href="https://www.facebook.com"
                    >
                      <FaFacebookF />
                    </a>
                  </li>
                  <li>
                    <a target="_blank" rel="noreferrer" href="https://x.com/">
                      <FaTwitter />
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href="https://www.instagram.com/"
                    >
                      <FaInstagram />
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href="https://www.youtube.com/"
                    >
                      <FaYoutube />
                    </a>
                  </li> */}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div
          className="footer-bottom bg-gray-black"
          style={{ fontSize: '.8em' }}
        >
          <div className="container">
            <div className="row">
              <div className="col-md-6 align-self-center">
                <p>
                  © AxisSoftSolutions {new Date().getFullYear()} | All Rights
                  Reserved
                </p>
              </div>
              <div className="col-md-6 text-lg-end">
                <Link to="/termsandconditions">
                  {t('terms-and-conditions')}
                </Link>
                <Link to="/privacypolicy">{t('privacy-policy')}</Link>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* ================== Footer Two  end ==================*/}
    </>
  );
};

export default FooterFour;
